module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TinyBox', {
    attrs: {
      "images": _vm.images
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }), _vm._v(" "), _vm._l((_vm.images), function(img, idx) {
    return _c('img', {
      staticClass: "open-tinybox",
      attrs: {
        "height": _vm.getHeight,
        "src": img.thumbnail,
        "alt": img.alt
      },
      on: {
        "click": function($event) {
          _vm.index = idx
        }
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-185ef1f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/TinyboxImageComponent.vue
// module id = 1241
// module chunks = 2